<template>
    <v-expansion-panel class="expansion">
        <v-expansion-panel-header>
            <div class="col-12 expansionHeaderText">
                <h6>Add a new block</h6>
            </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-expansion-panels accordion>
                <v-expansion-panel class="expansion">
                    <v-expansion-panel-header v-slot="{ open }">
                        <div class="col-12 expansionHeaderText" v-if="open">
                            <p>Apply/edit the filters for selector below.</p>
                        </div>
                        <div v-else class="col-12 expansionHeaderText">
                            <h6>Filters: </h6>
                            <p>{{newBlockFilters.fromSoftwareNameFilter !== '' ?
                                " from software: "+newBlockFilters.fromSoftwareNameFilter+",":""}}
                                {{newBlockFilters.fromSoftwareVersionFilter !== '' ?
                                " from version: "+newBlockFilters.fromSoftwareVersionFilter+",":""}}
                                {{newBlockFilters.toSoftwareNameFilter !== '' ?
                                " to software: "+newBlockFilters.toSoftwareNameFilter+",":""}}
                                {{newBlockFilters.toSoftwareVersionFilter !== '' ?
                                " to version: "+newBlockFilters.toSoftwareVersionFilter+",":""}}
                                {{newBlockFilters.groupFilter !== '' ?
                                " group:"+newBlockFilters.groupFilter:""}} </p>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="row">
                            <b-form-group
                                    label="from Software Filter"
                                    label-for="fromSoftwareNameFilter"
                                    class="col-6">
                                <b-form-select id="fromSoftwareNameFilter"
                                               :options="filterSelectorsOptions.fromSoftwareNameFilterOptions"
                                               v-model="newBlockFilters.fromSoftwareNameFilter"/>
                            </b-form-group>
                            <b-form-group
                                    label="from Version Filter"
                                    label-for="fromSoftwareVersionFilter"
                                    class="col-6">
                                <b-form-select id="fromSoftwareVersionFilter"
                                               :disabled="newBlockFilters.fromSoftwareNameFilter === ''"
                                               :options="fromSoftwareVersionFilterOptions"
                                               v-model="newBlockFilters.fromSoftwareVersionFilter"/>
                            </b-form-group>
                            <b-form-group
                                    label="to Software Filter"
                                    label-for="toSoftwareNameFilter"
                                    class="col-6">
                                <b-form-select id="toSoftwareNameFilter"
                                               :options="filterSelectorsOptions.toSoftwareNameFilterOptions"
                                               v-model="newBlockFilters.toSoftwareNameFilter"/>
                            </b-form-group>
                            <b-form-group
                                    label="to Version Filter"
                                    label-for="toSoftwareVersionFilter"
                                    class="col-6">
                                <b-form-select id="toSoftwareVersionFilter"
                                               :disabled="newBlockFilters.toSoftwareNameFilter === ''"
                                               :options="toSoftwareVersionFilterOptions"
                                               v-model="newBlockFilters.toSoftwareVersionFilter"/>
                            </b-form-group>
                            <b-form-group label="search for a group"
                                          label-for="groupFilter"
                                          class="col-12">
                                <b-form-select id="groupFilter"
                                               :options="filterSelectorsOptions.groupFilterOptions"
                                               v-model="newBlockFilters.groupFilter"/>
                            </b-form-group>

                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-divider/>
            <div class="row">
                <b-form-group label="The name of the class" label-for="className"
                              class="col-6 colLowPadding">
                    <b-form-select id="className" v-model="blockToAdd"
                                   :options="filteredBlockListForAddBtn"/>
                </b-form-group>
                <v-spacer/>
                <v-divider vertical/>
                <v-spacer/>
                <div class="mx-auto text-center mt-5 col-5">
                    <v-spacer/>
                    <v-btn @click="addBlock()" :style="primaryStyle" block>Add
                        block: {{this.blockToAdd.className !== ''? this.blockToAdd.className :
                        'empty block'}}
                    </v-btn>
                    <v-spacer/>
                </div>
            </div>
            <v-divider/>
            <div class="row">
                <v-spacer/>
                <div class="col-5">
                    <b-button @click="addCustomBlock()" class="btn-primary" block>Add custom block
                    </b-button>
                </div>
                <v-spacer/>
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
    import FilterBlocksService from '../../../../services/FilterBlocksService';

    export default {
        props: {
            currentBlocks: {
                type: Array,
                default: []
            },
            blocks: {
                type: Array,
                default: []
            },
            nextBlockIdProp: {
                type: Number,
                default: Number(process.env.VUE_APP_BLOCKEDITOR_MAX_BLOCKS + 1)
            }
        },
        data() {
            return {
                nextBlockId: this.nextBlockIdProp,
                maxBlocks: Number(process.env.VUE_APP_BLOCKEDITOR_MAX_BLOCKS),
                blockToAdd: {className: ''},
                newBlockFilters: {
                    fromSoftwareNameFilter: '',
                    fromSoftwareVersionFilter: '',
                    toSoftwareNameFilter: '',
                    toSoftwareVersionFilter: '',
                    groupFilter: '',
                },
                filterSelectorsOptions: {
                    fromSoftwareNameFilterOptions: [],
                    toSoftwareNameFilterOptions: [],
                    groupFilterOptions: [],
                    fromSoftwareVersions: [],
                    toSoftwareVersions: [],
                },
                filteredBlockListForAddBtn: [],
            }
        },
        methods: {
            addBlock() {
                if (this.currentBlocks.length < this.maxBlocks) {
                    let newBlock = {};
                    newBlock.id = this.nextBlockId;
                    this.nextBlockId++;
                    newBlock.blockType = this.blockToAdd.blockType;
                    if (this.blockToAdd.className === '') {
                        newBlock.className = '';
                        newBlock.blockType = 'BackendBlock';
                        this.currentBlocks.push(newBlock);
                    } else {
                        newBlock.className = this.blockToAdd.className;
                        newBlock.type = this.blockToAdd.type;
                        this.currentBlocks.push(newBlock);
                    }
                    this.$emit('next-block-id', this.nextBlockId);
                }
            },
            addCustomBlock() {
                if (this.currentBlocks.length < this.maxBlocks) {
                    let newBlock = {};
                    newBlock.id = this.nextBlockId;
                    this.nextBlockId++;
                    newBlock.blockType = 'CustomBlock';
                    newBlock.className = 'Custom Block';
                    newBlock.type = 'custom';
                    this.currentBlocks.push(newBlock);
                    this.$emit('next-block-id', this.nextBlockId);
                }
            },
        },
        created() {
            this.filterSelectorsOptions = FilterBlocksService.getFilterLists(this.blocks);
            this.filteredBlockListForAddBtn = FilterBlocksService.filterBlockList(this.newBlockFilters, this.blocks, false);
        },
        computed: {
            fromSoftwareVersionFilterOptions() {
                return FilterBlocksService.softwareVersionFilterOptions(this.filterSelectorsOptions.fromSoftwareVersions, this.newBlockFilters.fromSoftwareNameFilter);
            },
            toSoftwareVersionFilterOptions() {
                return FilterBlocksService.softwareVersionFilterOptions(this.filterSelectorsOptions.toSoftwareVersions, this.newBlockFilters.toSoftwareNameFilter);
            }
        },
        watch: {
            newBlockFilters: {
                handler(val) {
                    if (val.fromSoftwareNameFilter === '') {
                        this.newBlockFilters.fromSoftwareVersionFilter = '';
                    }
                    if (val.toSoftwareNameFilter === '') {
                        this.newBlockFilters.toSoftwareVersionFilter = '';
                    }
                    this.filteredBlockListForAddBtn = FilterBlocksService.filterBlockList(this.newBlockFilters, this.blocks, false);
                },
                deep: true
            },
            nextBlockIdProp(val) {
                this.nextBlockId = val;
            }
        }
    }
</script>
